import React from 'react';
import { Link, Route, Switch, useHistory, Redirect, useLocation } from 'react-router-dom';
import * as routes from '../../../constants/routes';
import { ArrowLeftIcon, CoinsIcon, HelpIcon, ProfileIcon, WalletIcon } from '../../../components/Icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Profile from './profile/Profile';
import Account from './account/Account';
import Financial from './financial/Financial';
import { PROFILE } from '../../../constants/routes';
import { SETTINGS_PROFILE } from '../../../constants/routes';
import { SETTINGS_ACCOUNT } from '../../../constants/routes';
import { SETTINGS_FINANCIAL } from '../../../constants/routes';
import { HELP_SUPPORT } from '../../../constants/routes';
import HelpSupport from './HelpSupport';

const Settings = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  return (
    <div className="settings-cont d-flex flex-grow-1 bg-dark">
      {
        <div className="settings-side-menu d-none d-sm-block bg-dark">
          <ul className="list-group list-group-flush pt-md-5">
            <li className="list-group-item border-0 bg-dark">
              <Link
                className={`${location.pathname === SETTINGS_PROFILE && 'text-primary'
                  } burger-link text-capitalize h5 d-flex align-items-center text-gray m-0 `}
                to={SETTINGS_PROFILE}
              >
                <ProfileIcon fill="currentColor" width={14} className="mr-3" />
                {t('profile')}
              </Link>
            </li>
            <li className="list-group-item  border-0 bg-dark">
              <Link
                className={`${location.pathname === SETTINGS_ACCOUNT && 'text-primary'
                  } burger-link text-capitalize h5 d-flex align-items-center text-gray m-0 `}
                to={SETTINGS_ACCOUNT}
              >
                <CoinsIcon fill="currentColor" width={14} className="mr-3" />
                {t('account')}
              </Link>
            </li>
            <li className="list-group-item border-0 bg-dark">
              <Link
                className={`${location.pathname === SETTINGS_FINANCIAL && 'text-primary'
                  } burger-link text-capitalize h5 d-flex align-items-center text-gray m-0 `}
                to={SETTINGS_FINANCIAL}
              >
                <WalletIcon fill="currentColor" width={14} className="mr-3" />
                {t('financial')}
              </Link>
            </li>
            <li className="list-group-item border-0 bg-dark">
              <a
                className={` burger-link text-capitalize h5 d-flex align-items-center text-gray m-0 `}
                href="mailto:info@crwd.tv?subject=CRWD Support"
                rel="noreferrer"
                target="_blank"
              >
                <HelpIcon fill="currentColor" width={14} className="mr-3" />
                {t('help & support')}
              </a>
            </li>
          </ul>
        </div>
      }
      <div className="d-flex flex-grow-1">
        <Switch>
          <Route exact={true} path={SETTINGS_PROFILE} component={Profile} />
          <Route exact={true} path={SETTINGS_ACCOUNT} component={Account} />
          <Route exact={true} path={SETTINGS_FINANCIAL} component={Financial} />
          <Route exact={true} path={HELP_SUPPORT} component={HelpSupport} />
          <Redirect to={SETTINGS_PROFILE} />
        </Switch>
      </div>
    </div>
  );
};

export default Settings;
